import { NxProgressbarModule } from '@allianz/ng-aquila/progressbar';
import { Component, computed, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthorizationStep, CampaignAuthorizationService } from '../../services/campaign-authorization.service';

const STEPS: readonly AuthorizationStep[] = ['loading-business-units', 'checking-permissions'];

const STEP_LABELS: Record<AuthorizationStep, string> = {
  'loading-business-units': 'Loading business units…',
  'checking-permissions': 'Checking your permissions…',
};

/**
 * Shown only while a live campaign-authorization resolution is in flight — the service's
 * `currentStep` stays `undefined` on a cache hit (synchronous, no network wait), so nothing
 * renders in that case (AZTGSA-12354 design.md, Decision 8).
 */
@Component({
  selector: 'app-authorization-progress',
  imports: [NxProgressbarModule, TranslocoPipe],
  templateUrl: './authorization-progress.component.html',
  styleUrl: './authorization-progress.component.scss',
})
export class AuthorizationProgressComponent {
  private readonly authorizationService = inject(CampaignAuthorizationService);

  private readonly currentStep = this.authorizationService.currentStep;

  readonly visible = computed(() => this.currentStep() !== undefined);

  readonly stepLabel = computed(() => {
    const step = this.currentStep();
    return step ? STEP_LABELS[step] : '';
  });

  readonly stepValue = computed(() => {
    const step = this.currentStep();
    return step ? STEPS.indexOf(step) + 1 : 0;
  });

  readonly stepCount = STEPS.length;
}
